<footer class="site-footer">
  <div class="container footer-inner">
    <div class="footer-brand">
      <a class="footer-logo" routerLink="/" (click)="onLogoClick()">
        <img [src]="logoSrc" alt="Tricore Holdings logo" />
      </a>
      <p class="footer-title">Tricore Holdings Pvt. Ltd.</p>
      <p class="footer-text">
        A Diverse Venture Building Platform for Future Innovation Empires
      </p>
    </div>

    <div class="footer-links">
      <p class="footer-heading">Explore</p>
      <button
        class="footer-jump"
        type="button"
        *ngFor="let section of sections"
        (click)="onSectionClick(section.id)"
        [class.is-active]="scrollSpy.isActive(section.id)"
      >
        {{ section.label }}
      </button>
    </div>

    <div class="footer-links">
      <p class="footer-heading">Support</p>
      <a
        class="footer-link"
        routerLink="/faq"
        routerLinkActive="is-active"
      >
        FAQs
      </a>
      <a
        class="footer-link"
        routerLink="/contact-us"
        routerLinkActive="is-active"
      >
        Contact Us
      </a>
      <a
        class="footer-link"
        routerLink="/privacy-policy"
        routerLinkActive="is-active"
      >
        Privacy Policy
      </a>
      <a
        class="footer-link"
        routerLink="/company-policy"
        routerLinkActive="is-active"
      >
        Company Policy
      </a>
    </div>
  </div>

  <div class="footer-bottom">
    <p>(c) {{ year }} Tricore Holdings Pvt. Ltd. All rights reserved.</p>
  </div>
</footer>
